import PropTypes from 'prop-types';
import React from 'react';

class ScrollIntoView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasDone: false,
    };
  }

  processRef = (element) => {
    let {
      hasDone,
    } = this.state;

    if (hasDone || !element) {
      return;
    }

    element.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });

    this.setState({
      hasDone: true,
    });
  }

  render = () => {
    let {
      children,
      style,
    } = this.props;

    return (
      <div
        ref={this.processRef}
        style={style}
      >
        {children}
      </div>
    );
  }
}

ScrollIntoView.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  style: PropTypes.object,
};

export default ScrollIntoView;
